var map = {
	"./Salesforceref.png": 120,
	"./adobe.png": 985,
	"./amazon.png": 970,
	"./cisco.png": 161,
	"./googleref.png": 436,
	"./ibm.png": 582,
	"./microsoft.png": 348,
	"./oracle.png": 724
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 188;